var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floating-box"},[_c('header',[_c('h1',[_vm._v(_vm._s(_vm.params.title))]),_vm._v(" "),_c('button',{on:{"click":_vm.onClose}},[_vm._v("x")])]),_vm._v(" "),_c('main',[_c('p',[_vm._v(_vm._s(_vm.params.text))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83634d14","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/boxes/FloatingBox.vue
// module id = null
// module chunks = 